module.exports = __webpack_public_path__ + "img/CeltCapTechCallOfTheStag.dcc0eade.webp";